import React from 'react'

import renaud from '../assets/self/renaud_couteau.jpg'
import edouard from '../assets/self/edouard.jpg'
import guillaume from '../assets/self/guillaume-louis-muscu.jpg'
import nicolas from '../assets/self/nicolas.jpg'

const Self = () => {
    return (
        <section id="self" className="relative py-20 overflow-hidden bg-gradient-to-br from-gray-50 to-white">
            {/* Éléments décoratifs en arrière-plan */}
            <div className="absolute top-0 left-0 w-72 h-72 bg-gradient-to-br from-primary/10 to-red-200/20 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-red-100/30 to-primary/10 rounded-full blur-3xl"></div>
            
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="lg:grid lg:grid-cols-2 lg:gap-16 lg:items-center">
                    
                    {/* Section texte modernisée */}
                    <div className="space-y-8">
                        <div className="space-y-4">
                            <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-primary to-red-600 text-white text-sm font-semibold rounded-full shadow-lg">
                                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                                </svg>
                                Self Défense
                            </div>
                            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                                Apprenez à vous 
                                <span className="block text-primary">défendre</span>
                            </h2>
                            <p className="text-xl text-gray-600 leading-relaxed">
                                Acquérez des réflexes de base pour prévenir les ennuis et sortir sans problème d'une situation potentiellement dangereuse. Le tout dans une ambiance bienveillante et motivante !
                            </p>
                        </div>
                        
                        {/* Avantages avec design moderne */}
                        <div className="grid grid-cols-2 md:grid-cols-2 gap-4 md:gap-6">
                            {[
                                { icon: "💪", title: "Se défouler", desc: "Évacuez le stress" },
                                { icon: "🥋", title: "Se muscler", desc: "Renforcez votre corps" },
                                { icon: "🤝", title: "Bonne ambiance", desc: "Esprit d'équipe" },
                                { icon: "🧘", title: "Confiance", desc: "Gagnez en assurance" }
                            ].map((item, index) => (
                                <div key={index} className="group flex items-start space-x-3 sm:space-x-4 p-3 sm:p-4 rounded-xl sm:rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100">
                                    <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-primary/10 to-red-100 rounded-lg sm:rounded-xl flex items-center justify-center text-lg sm:text-xl group-hover:scale-110 transition-transform duration-300">
                                        {item.icon}
                                    </div>
                                    <div>
                                        <h3 className="text-sm sm:text-base font-semibold text-gray-900 group-hover:text-primary transition-colors duration-300">
                                            {item.title}
                                        </h3>
                                        <p className="text-xs sm:text-sm text-gray-600 mt-1">{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        
                        {/* Call to action */}
                        <div className="pt-6">
                            <a href="#price" className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-primary to-red-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300">
                                <span>Découvrir nos tarifs</span>
                                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                                </svg>
                            </a>
                        </div>
                    </div>
                    
                    {/* Section images modernisée */}
                    <div className="relative mt-12 lg:mt-0">
                        <div className="relative">
                            {/* Grille d'images avec effets modernes */}
                            <div className="grid grid-cols-2 gap-4">
                                <div className="space-y-4">
                                    <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500">
                                        <img 
                                            className="w-full h-48 object-cover transform group-hover:scale-110 transition-transform duration-500" 
                                            src={renaud} 
                                            alt="Techniques de self-défense" 
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        <div className="absolute bottom-4 left-4 text-white font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            Techniques avancées
                                        </div>
                                    </div>
                                    <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500">
                                        <img 
                                            className="w-full h-40 object-cover transform group-hover:scale-110 transition-transform duration-500" 
                                            src={nicolas} 
                                            alt="Entraînement self-défense" 
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        <div className="absolute bottom-4 left-4 text-white font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            Préparation physique
                                        </div>
                                    </div>
                                </div>
                                <div className="space-y-4 pt-8">
                                    <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500">
                                        <img 
                                            className="w-full h-40 object-cover transform group-hover:scale-110 transition-transform duration-500" 
                                            src={edouard} 
                                            alt="Cours de self-défense" 
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        <div className="absolute bottom-4 left-4 text-white font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            Cours collectifs
                                        </div>
                                    </div>
                                    <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500">
                                        <img 
                                            className="w-full h-48 object-cover transform group-hover:scale-110 transition-transform duration-500" 
                                            src={guillaume} 
                                            alt="Renforcement musculaire" 
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        <div className="absolute bottom-4 left-4 text-white font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            Renforcement
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Badge flottant */}
                            <div className="absolute -top-4 -right-4 bg-gradient-to-r from-primary to-red-600 text-white px-6 py-3 rounded-full shadow-lg transform rotate-12">
                                <div className="text-center">
                                    <div className="text-sm font-semibold">Mercredis</div>
                                    <div className="text-xs">19h30-21h</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Section informations pratiques */}
                <div className="mt-16 bg-white rounded-3xl shadow-xl p-6 md:p-8 border border-gray-100">
                    <div className="text-center mb-8">
                        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Informations pratiques</h3>
                        <p className="text-gray-600">Tous les détails pour rejoindre nos cours de self-défense</p>
                    </div>
                    
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
                        <div className="text-center">
                            <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                            </div>
                            <h4 className="text-sm md:text-base font-semibold text-gray-900 mb-1 md:mb-2">Horaires</h4>
                            <p className="text-gray-600 text-xs md:text-sm">Mercredis<br/>19h30 - 21h00</p>
                        </div>
                        
                        <div className="text-center">
                            <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                </svg>
                            </div>
                            <h4 className="text-sm md:text-base font-semibold text-gray-900 mb-1 md:mb-2">Lieu</h4>
                            <p className="text-gray-600 text-xs md:text-sm">Artenium<br/>4 parc de l'artière, Ceyrat</p>
                        </div>
                        
                        <div className="text-center col-span-2 md:col-span-1">
                            <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
                                </svg>
                            </div>
                            <h4 className="text-sm md:text-base font-semibold text-gray-900 mb-1 md:mb-2">Niveau</h4>
                            <p className="text-gray-600 text-xs md:text-sm">Tous niveaux<br/>Débutants bienvenus</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Self
